import { TOGGLE_ALERT } from '../actions';

export default function(state = { message: "", error: false }, action) {
  switch (action.type) {
  case TOGGLE_ALERT: {
    return { ...state, message: action.message, error: action.error };
  }
  default: {
    return state;
  }
  }
}
